import { Box } from '@material-ui/core';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React, { useState } from 'react';
import { CgClose } from 'react-icons/cg';
import HeroIcon from '@atoms/HeroIcon/HeroIcon';
import Button from '@atoms/Button/Button';
import Section from '@atoms/Section/Section';
import Title from '@atoms/Title/Title';
import SocialMediaLinks from '../SocialMediaLinks/SocialMediaLinks';
import { useLocale } from '@hooks';
import LanguageSwitcher from '../translation';
import { SubMenu } from './HeaderNav';
import HeaderNavSubMenuListMobile from './HeaderNavSubMenuListMobile';
import HeaderNavSubMenuChapter from './HeaderNavSubMenuChapter';
import HeaderNavFooterCtaGroup from './HeaderNavFooterCtaGroup';

interface Props {
    onClose: VoidFunction;
    isShown: boolean;
    list: SubMenu[];
}

const NavMobile: React.FC<Props> = ({ isShown, onClose, list }) => {
    const [tab, setTab] = useState<string | null>(null);
    const { t } = useTranslation();
    const { getAppLinkWithCurrentLang } = useLocale();

    const mod_class = ['NavMobile', isShown === true ? 'is-open' : ''].join(
        ' '
    );

    return (
        <div className={mod_class}>
            <Section theme="dark">
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <HeroIcon size="xs" theme="white" onClick={onClose}>
                        <CgClose />
                    </HeroIcon>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                    >
                        <a
                            href={getAppLinkWithCurrentLang(
                                'https://app.aepsy.com/login'
                            )}
                        >
                            <Button
                                label={t('nav.label.login')}
                                variant="outlined"
                                theme="white"
                                size="xxs"
                                radius="xxs"
                            />
                        </a>
                        <Box sx={{ ml: 1 }}>
                            <LanguageSwitcher
                                id="LanguageSwitcherNavMobile"
                                theme="white"
                                horizontal="right"
                                size="xxs"
                            />
                        </Box>
                    </Box>
                </Box>

                <Section spacingTop="s">
                    <HeaderNavSubMenuChapter />
                </Section>

                {list.map((item) => (
                    <HeaderNavSubMenuListMobile
                        data={item}
                        tab={tab}
                        setTab={setTab}
                    />
                ))}

                <SocialMediaLinks />

                <Section spacingTop="l">
                    <a
                        href={getAppLinkWithCurrentLang(
                            process.env.GATSBY_START_FULL_FUNNEL_URL
                        )}
                    >
                        <Button
                            label={t('nav.cta.mini.block.cta')}
                            theme="pink-gradient"
                            isFullsize
                        />
                    </a>
                </Section>
            </Section>
        </div>
    );
};

export default NavMobile;
